module.exports = __webpack_public_path__ + "static/grand-mere.d7f48820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grand-mere.png
// module id = 557
// module chunks = 111848116438363